<div class="progress-cont">
  <div class="progress" [style.width]="progress + '%'" [style.background]="status">
  </div>
</div>
